import React, { memo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { IconButton, MdiIcon } from '@mic3/platform-ui';
import history from 'store/History';
import { get } from 'app/utils/lo/lo';

const ArrowStyled = styled(MdiIcon)``;

const StyledIconButton = styled(IconButton)`
    &.MuiButtonBase-root {
        padding-left: 0 !important;
    }
`;

const ArrowBack = ({ left, goBack }) => {
    const leftPanelBack = useSelector(state => state.leftPanel.state.showBack);
    let withGoBack = false
    if (Array.isArray(left)) {
        withGoBack = get(left, '[0].props.withGoBack');
    } else if (get(left, 'props.withGoBack') !== undefined) {
        withGoBack = get(left, 'props.withGoBack');
    } else {
        withGoBack = get(left, 'props.children[0].props.withGoBack');
    }


    const handleGoBack = useCallback(() => {
        if (goBack) {
            return goBack();
        }

        history.goBack();
    }, [goBack]);

    return (
        <>
            {!leftPanelBack && withGoBack &&
                (
                    <StyledIconButton title="back" onClick={handleGoBack} >
                        <ArrowStyled name="arrow-left" />
                    </StyledIconButton>
                )}
        </>
    );
};

export default memo(ArrowBack);
